import { render } from "./BulletList.vue?vue&type=template&id=365bb2cf"
import script from "./BulletList.vue?vue&type=script&lang=js"
export * from "./BulletList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__